module.exports = __webpack_public_path__ + "img/doc.c04db467.svg";